module.exports = __webpack_public_path__ + "img/about-goldenrod-sp.ae19c1db.jpg";